<template>
    <b-modal v-model="modalAberto" size="lg" @hidden="cancelar" button-size="md" hide-footer
        :title="'Item Bem Permanente > Documento do Item Bem Permanente > '+(edicao?'Edição': 'Cadastro')" >
        <DocumentoIBPAdicionar :edicao="edicao" @fecharModal="cancelar" :modal="true"  :idDocumento="idDocumento" :id="id"></DocumentoIBPAdicionar>
    </b-modal>
</template>

<script>

import DocumentoIBPAdicionar from '@/modules/patrimonio/documentoibp/DocumentoIBPAdicionar.vue';

export default {
    name: "ModalDocumentoIBPAdicionar",
    components: {
        DocumentoIBPAdicionar,
    },
    props: {
        id: Number,
        edicao: Boolean,
        idDocumento: Number

    },
    data() {
        return {
            modalAberto: true,
        }
    },
    methods: {
        cancelar() {
            this.$emit('fecharModal');
        },

    }
}

</script>